import React, { useState, useEffect } from 'react';
import { AlertCircle } from 'lucide-react';

const AgeVerification = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if age has been verified in localStorage
    const ageVerified = localStorage.getItem('ageVerified');
    const currentPath = window.location.pathname;
    
    // If age was denied, only block if not already on responsible gaming page
    if (ageVerified === 'denied' && currentPath !== '/responsible-gaming') {
      window.location.href = '/responsible-gaming';
      return;
    }
    
    // If not verified yet, show the popup
    if (!ageVerified) {
      setIsVisible(true);
      // Prevent body scroll when popup is visible
      document.body.style.overflow = 'hidden';
    }
    
    return () => {
      // Restore body scroll when component unmounts
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleConfirm = () => {
    localStorage.setItem('ageVerified', 'true');
    localStorage.setItem('ageVerifiedDate', new Date().toISOString());
    setIsVisible(false);
    document.body.style.overflow = 'unset';
  };

  const handleDeny = () => {
    // Store denial in localStorage to prevent showing again
    localStorage.setItem('ageVerified', 'denied');
    localStorage.setItem('ageVerifiedDate', new Date().toISOString());
    // Redirect to responsible gaming page
    window.location.href = '/responsible-gaming';
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <div className="glass-strong rounded-3xl p-8 md:p-10 max-w-md mx-4 relative">
        <div className="flex items-center justify-center mb-6">
          <div className="w-20 h-20 bg-gradient-to-br from-brown-600 to-brown-800 rounded-full flex items-center justify-center">
            <AlertCircle className="w-10 h-10 text-white" />
          </div>
        </div>
        
        <h2 className="text-3xl font-bold text-brown-900 mb-4 text-center">
          Age Verification Required
        </h2>
        
        <p className="text-lg text-brown-700 mb-6 text-center leading-relaxed">
          You must be 18 years or older to access this website. By continuing, you confirm that you are of legal gambling age in the United Kingdom.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <button
            onClick={handleConfirm}
            className="flex-1 px-6 py-3 bg-gradient-to-r from-brown-700 to-brown-900 text-white rounded-full font-semibold hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
          >
            I am 18 or older
          </button>
          <button
            onClick={handleDeny}
            className="flex-1 px-6 py-3 glass text-brown-900 rounded-full font-semibold hover:bg-white/40 transition-all duration-300"
          >
            I am under 18
          </button>
        </div>
        
        <p className="text-sm text-brown-600 text-center mt-6">
          This site contains information about gambling. Please gamble responsibly.
        </p>
      </div>
    </div>
  );
};

export default AgeVerification;

